// extracted by mini-css-extract-plugin
module.exports = {"itemSelected":"MultiSelectItem_itemSelected__5XHpm"};